// extracted by mini-css-extract-plugin
export default {"btop":"_1a36f25dc9 d903fbdf12 a2ee5830f0","icon":"beafef3b31 _7aacaf6f31","btoppink":"_7bee72607d _9a9ab3ba00"};